const Paginator = ({ pagination, onPageChange, children }) => {
    if (!pagination) return null;

    const { currentPage, lastPage, perPage, total } = pagination;

    const start = (currentPage - 1) * perPage + 1;
    const end = Math.min(currentPage * perPage, total);

    const pages = [];
    for (let i = 1; i <= lastPage; i++) {
        pages.push(i);
    }

    return (
        total > perPage ? 
        <div className="paginator">
            {/* Top info */}
            <div className="paginator__info">
                Showing <strong>{start}</strong> – <strong>{end}</strong> of <strong>{total}</strong>
            </div>

            {/* Wrapped children */}
            {children}

            {/* Bottom controls */}
            <div className="paginator__controls">
                <a
                    className="paginator__button"
                    onClick={currentPage !== 1 ? () => onPageChange(currentPage - 1) : undefined}
                >
                    ‹
                </a>

                <div className="paginator__pages">
                    {pages.map((page) => (
                        <a
                            key={page}
                            className={`paginator__page ${page === currentPage ? 'active' : ''}`}
                            onClick={() => onPageChange(page)}
                        >
                            {page}
                        </a>
                    ))}
                </div>

                <a
                    className="paginator__button"
                    onClick={currentPage !== lastPage ? () => onPageChange(currentPage + 1) : undefined}
                >
                    ›
                </a>
            </div>
        </div>
        : <>{children}</>
    );
};

export default Paginator;